import { BuyerDashboardPage } from "@b2b/ui-components/features/BuyerDashboard";

export default function BuyerDashboard() {
    return <BuyerDashboardPage />;
}